const STORAGE_PREFIX = "aam:submitted:";

export function getStoredSubmissionId(token: string): string | null {
  try {
    return sessionStorage.getItem(`${STORAGE_PREFIX}${token}`);
  } catch {
    return null;
  }
}

export function storeSubmissionId(token: string, submissionId: string): void {
  try {
    sessionStorage.setItem(`${STORAGE_PREFIX}${token}`, submissionId);
  } catch {
    // Non-critical if storage is unavailable.
  }
}

export function clearStoredSubmissionId(token: string): void {
  try {
    sessionStorage.removeItem(`${STORAGE_PREFIX}${token}`);
  } catch {
    // Non-critical if storage is unavailable.
  }
}

export const APPLICATION_COMPLETE_STEP = "complete";

export function applicationCompletePath(token: string): string {
  return `/agent-form/${token}/${APPLICATION_COMPLETE_STEP}`;
}
